import { readableSegmentType } from '~/lib/segments';

import EmptySearchIcon from './EmptySearch.svg';
import styles from './styles';

const EmptySearch = ({ searchQuery, classes, inSegment, segmentType }) => {
  return (
    <div className={classes.root}>
      <EmptySearchIcon />
      <h1 className={classes.emptySearchHeadline}>
        There are no {readableSegmentType(segmentType)}{' '}
        {inSegment && 'in this segment '}matching &apos;
        <span className={classes.searchQuery}>{searchQuery}</span>&apos;
      </h1>
    </div>
  );
};

EmptySearch.propTypes = {
  searchQuery: PropTypes.string,
  classes: PropTypes.shape({}),
  inSegment: PropTypes.bool,
  segmentType: PropTypes.string,
};

export default withStyles(styles)(EmptySearch);
